class mobileOnly {
	constructor() {
		this.removeMobileOnly();
	}

	removeMobileOnly() {
		var bodyStyle = getComputedStyle(document.body);
		var breakpoint = bodyStyle.getPropertyValue('--breakpoint-lg').replace('px', '');
		if (screen.width >= breakpoint) {
			$('.mobile-only').remove();
		}
	}
}

export default new mobileOnly();